import React, { useState } from "react";
import { Panel, Button, Input, InputNumber, Message, toaster, Header, Heading, IconButton } from "rsuite";
import { LuCopy } from "react-icons/lu";
import axios from "../axiosIn";

export const DespacitosMTB = () => {
  const [idCarrera] = useState(202508);
  const [equipo] = useState("DESPACITOS MTB");
  const [nombre, setNombre] = useState("");
  const [monto, setMonto] = useState(0);
  const [file, setfile] = useState(null);

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const handleChangeComprob = (e) => {
    if (e.target.value != "") {
      setfile(e.target.files[0]);
    }
  };

  const save = async () => {
    const formData = new FormData();
    formData.append("idCarrera", idCarrera);
    formData.append("equipo", equipo);
    formData.append("nombre", nombre);
    formData.append("monto", monto);
    formData.append("comprobante", file);

    var url = `Registro/saveAportacion`;

    if (!nombre || !monto || !file) {
      toast(
        "Los datos estan incompletos, debes llenar todos los campos.",
        "warning"
      );
      return;
    }

    if (monto === "0") {
      toast("El monto no puede ser cero.", "warning");
      return;
    }

    await axios
      .post(url, formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (res) => {
        if (res.data === 1) {
          toast(
            "Se ha registrado la información de forma correcta.",
            "success"
          );
          setTimeout(() => {
            window.location.reload();
          }, [1000]);
        } else {
          toast(
            "No se registro la información, valida tu conexión de red.",
            "error"
          );
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div className="App">
      <div className="container">
        <Header
          style={{
            backgroundColor: "#f9f7f6",
            height: "auto",
            padding: "20px",
            borderRadius: "15px",
            opacity: 0.9,
          }}
        >
					<Heading level={5}>Datos para Deposito</Heading>
          <Heading level={5}>
            Banco: <b>SPIN DE OXXO</b>
            <br />
            Beneficiario: JOSUÉ EZEQUIEL SALAZAR CERDAN
            <br />
						<br />
            Tarjeta: <b>4217 4700 1405 1078</b>&nbsp;&nbsp;
            <IconButton
              appearance="link"
              style={{ fontSize: "18px" }}
              icon={<LuCopy></LuCopy>}
              onClick={() => this.copiarValor(`4217470014051078`)}
            ></IconButton>
            <br></br>
            {/* <br />
                  {/* Cuenta: <b>150 28 93184</b>&nbsp;&nbsp; */}
            Clabe: <b>7289 6900 0022 7132 48</b>&nbsp;&nbsp;
            <IconButton
              appearance="link"
              style={{ fontSize: "18px" }}
              icon={<LuCopy></LuCopy>}
              onClick={() => this.copiarValor(`728969000022713248`)}
            ></IconButton>
            <br />
            <br />
            <h6 style={{ backgroundColor: "yellow" }}>
              * IMPORTANTE: En el concepto de la transferencia anota tu NOMBRE
              COMPLETO, para una identificación más rapida.
            </h6>
          </Heading>
        </Header>
      </div>
      <div className="App container" style={{ marginTop: 20 }}>
        <Panel header={`Aportaciones - ${equipo}`} bordered shaded>
          <div className="card" style={{ padding: "20px" }}>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Nombre completo</b>
                <Input
                  name="nombre"
                  placeholder="Nombre completo"
                  autoFocus
                  onChange={(e) => setNombre(e)}
                />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <b>Monto</b>
                <InputNumber
                  min={0}
                  name="monto"
                  onChange={(e) => setMonto(e)}
                />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <b>Subir comprobante</b>
                <input
                  type="file"
                  id="comprobante"
                  name="comprobante"
                  accept=".jpg"
                  onChange={handleChangeComprob}
                />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <br></br>
                <Button appearance="primary" block onClick={() => save()}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  );
};
